export var questionTypes: Array<any> = [
  {
    name: 'QUESTIONTYPE_QUESTIONTYPENAME_2A7D7C31-524C-4625-B6E9-895B110E0F5D',  
    id: "2A7D7C31-524C-4625-B6E9-895B110E0F5D",
  },
  {
    name: 'QUESTIONTYPE_QUESTIONTYPENAME_AC6235D3-1399-45CE-B6F5-9E997D1F467C',
    id: "AC6235D3-1399-45CE-B6F5-9E997D1F467C",
  },
  {
    name: 'QUESTIONTYPE_QUESTIONTYPENAME_3E8A3A99-CA82-4D8A-B733-06BF851D239F',
    id: "3E8A3A99-CA82-4D8A-B733-06BF851D239F",
  },
];

export var questionTypesMap: Array<any> = [
  {
    key: 'all',
    short: 'CHECK.EVALUATION.ALL_QUESTION_TYPES',
    abbr: 'CHECK.EVALUATION.ALL_QUESTION_TYPES',
    name: 'CHECK.EVALUATION.ALL_QUESTION_TYPES',
    id: "ALL",
  },
  {
    key: 'yesNo',
    short: 'QUESTIONTYPE_QUESTIONTYPENAME_2A7D7C31-524C-4625-B6E9-895B110E0F5D', 
    abbr: 'QUESTIONTYPE_QUESTIONTYPENAME_2A7D7C31-524C-4625-B6E9-895B110E0F5D',  
    name: 'QUESTIONTYPE_QUESTIONTYPENAME_2A7D7C31-524C-4625-B6E9-895B110E0F5D',  
    id: "2A7D7C31-524C-4625-B6E9-895B110E0F5D",
  },
  {
    key: 'star',
    short: 'QUESTIONTYPE_QUESTIONTYPENAME_AC6235D3-1399-45CE-B6F5-9E997D1F467C',
    abbr: 'QUESTIONTYPE_QUESTIONTYPENAME_AC6235D3-1399-45CE-B6F5-9E997D1F467C',
    name: 'QUESTIONTYPE_QUESTIONTYPENAME_AC6235D3-1399-45CE-B6F5-9E997D1F467C',
    id: "AC6235D3-1399-45CE-B6F5-9E997D1F467C",
  },
  {
    key: 'score',
    short: 'QUESTIONTYPE_QUESTIONTYPENAME_3E8A3A99-CA82-4D8A-B733-06BF851D239F',
    abbr: 'QUESTIONTYPE_QUESTIONTYPENAME_3E8A3A99-CA82-4D8A-B733-06BF851D239F',
    name: 'QUESTIONTYPE_QUESTIONTYPENAME_3E8A3A99-CA82-4D8A-B733-06BF851D239F',
    id: "3E8A3A99-CA82-4D8A-B733-06BF851D239F",
  }
];